import React, { Component } from 'react';
import axios from 'axios';
import config from '../../../config';

const AVATARS = ['SR', 'MK', 'AL', 'JP'];
const AVATAR_COLORS = ['#166534', '#0d4f3c', '#15803d', '#14532d'];

class NewsletterSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedType: 'participant',
      email: '',
      status: 'idle',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    const { currentUser } = this.props;
    const { email, selectedType } = this.state;
    const trimmedEmail = email.trim();

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
      this.setState({ status: 'error' });
      return;
    }

    const publicData =
      currentUser &&
      currentUser.attributes &&
      currentUser.attributes.profile &&
      currentUser.attributes.profile.publicData;
    const userType = currentUser
      ? publicData && publicData.isProvider ? 'coach' : 'participant'
      : selectedType;

    this.setState({ status: 'submitting' });

    axios
      .post(`${config.coachSaaSService}marketing/newsletter-subscribe`, { email: trimmedEmail, userType })
      .then(() => this.setState({ status: 'success' }))
      .catch(() => this.setState({ status: 'error' }));
  }

  render() {
    const { currentUser } = this.props;
    const { selectedType, email, status } = this.state;

    const publicData =
      currentUser &&
      currentUser.attributes &&
      currentUser.attributes.profile &&
      currentUser.attributes.profile.publicData;
    const isProvider = !!(publicData && publicData.isProvider);
    const activeType = currentUser ? (isProvider ? 'coach' : 'participant') : selectedType;

    const subtext = activeType === 'coach'
      ? 'Get practice-building tips, platform updates, and coaching spotlights.'
      : 'Get matched with coaches and receive bi-weekly tips for your personal growth journey.';

    return (
      <div id="newsletter" style={s.wrapper}>

        {/* ── HERO (dark green top) ── */}
        <div style={s.hero}>
          {/* decorative circles */}
          <div style={{ ...s.decCircle, width: 200, height: 200, top: -60, right: 60, opacity: 0.08 }} />
          <div style={{ ...s.decCircle, width: 130, height: 130, top: 20, right: 180, opacity: 0.06 }} />

          <div style={s.heroInner}>
            {/* left */}
            <div style={s.heroLeft}>
              <div style={s.pill}>
                <span style={s.pillDot} />
                VIVEKA NEWSLETTER
              </div>
              <h2 style={s.heroTitle}>
                The coaching edge,{' '}
                <span style={s.heroTitleAccent}>delivered bi-weekly.</span>
              </h2>
              <p style={s.heroSub}>
                Curated tips, coach spotlights, and Viveka updates — tailored
                to whether you're growing or guiding.
              </p>
              <div style={s.statsRow}>
                <div style={s.stat}>
                  <span style={s.statNum}>Bi-weekly</span>
                  <span style={s.statLabel}>Delivery</span>
                </div>
                <div style={s.statDivider} />
                <div style={s.stat}>
                  <span style={s.statNum}>Free</span>
                  <span style={s.statLabel}>Always</span>
                </div>
              </div>
            </div>

            {/* right — avatar group */}
            <div style={s.heroRight}>
              <div style={s.avatarGroup}>
                {AVATARS.map((initials, i) => (
                  <div
                    key={initials}
                    style={{ ...s.avatar, background: AVATAR_COLORS[i], marginLeft: i === 0 ? 0 : -10, zIndex: AVATARS.length - i }}
                  >
                    {initials}
                  </div>
                ))}
              </div>
              <div style={s.avatarMeta}>
                <span style={s.avatarMetaNum}>Built for coaches & clients</span>
                <span style={s.avatarMetaSub}>join from the start</span>
              </div>
            </div>
          </div>
        </div>

        {/* ── FORM (light bottom) ── */}
        <div style={s.formSection}>
          <div style={s.formInner}>

            {/* left col */}
            <div style={s.formLeft}>
              {!currentUser && (
                <>
                  <p style={s.iAmA}>I AM A —</p>
                  <div style={s.toggleRow}>
                    <button
                      type="button"
                      style={activeType === 'participant' ? s.toggleActive : s.toggleInactive}
                      onClick={() => this.setState({ selectedType: 'participant' })}
                    >
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ marginRight: 6 }}>
                        <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
                      </svg>
                      Participant
                    </button>
                    <button
                      type="button"
                      style={activeType === 'coach' ? s.toggleActive : s.toggleInactive}
                      onClick={() => this.setState({ selectedType: 'coach' })}
                    >
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ marginRight: 6 }}>
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
                      </svg>
                      Coach
                    </button>
                  </div>
                </>
              )}

              {currentUser && (
                <div style={s.roleBadge}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <path d="M20 6L9 17l-5-5" />
                  </svg>
                  Subscribing as {isProvider ? 'Coach' : 'Participant'}
                </div>
              )}

              <p style={s.subtext}>{subtext}</p>

              {status === 'success' ? (
                <div style={s.successBox}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5">
                    <circle cx="12" cy="12" r="10" /><path d="M9 12l2 2 4-4" />
                  </svg>
                  You have successfully subscribed to our newsletter!
                </div>
              ) : (
                <form onSubmit={this.handleSubmit} noValidate>
                  <div style={s.inputRow}>
                    <div style={s.inputWrap}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" style={s.inputIcon}>
                        <rect x="2" y="4" width="20" height="16" rx="2" /><path d="M22 7l-10 7L2 7" />
                      </svg>
                      <input
                        type="email"
                        style={{ ...s.emailInput, borderColor: status === 'error' ? '#fca5a5' : '#e2e8f0' }}
                        placeholder="your@email.com"
                        value={email}
                        onChange={e => this.setState({ email: e.target.value, status: 'idle' })}
                        autoComplete="email"
                      />
                    </div>
                    <button
                      type="submit"
                      style={status === 'submitting' ? { ...s.submitBtn, opacity: 0.7 } : s.submitBtn}
                      disabled={status === 'submitting'}
                    >
                      {status === 'submitting' ? 'Subscribing…' : 'Subscribe'}
                    </button>
                  </div>
                  {status === 'error' && <p style={s.errorMsg}>Please enter a valid email address.</p>}
                </form>
              )}

              <p style={s.disclaimer}>No spam. Unsubscribe anytime.</p>
            </div>

            {/* right col — what you get */}
            <div style={s.formRight}>
              <p style={s.whatLabel}>WHAT YOU GET</p>
              {[
                {
                  icon: (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" /><path d="M12 8v4l3 3" />
                    </svg>
                  ),
                  title: 'Bi-weekly tips',
                  desc: 'Actionable coaching and growth insights.',
                },
                {
                  icon: (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
                    </svg>
                  ),
                  title: 'Coach spotlights',
                  desc: 'Meet coaches making an impact.',
                },
                {
                  icon: (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2">
                      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 0 1-3.46 0" />
                    </svg>
                  ),
                  title: 'Platform updates',
                  desc: 'New features and Viveka news first.',
                },
              ].map(item => (
                <div key={item.title} style={s.benefitRow}>
                  <div style={s.benefitIcon}>{item.icon}</div>
                  <div>
                    <p style={s.benefitTitle}>{item.title}</p>
                    <p style={s.benefitDesc}>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    );
  }
}

const s = {
  wrapper: {
    maxWidth: '100%',
    margin: '32px auto',
    borderRadius: '16px',
    overflow: 'hidden',
    border: '1px solid #e2e8f0',
    boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
  },

  /* hero */
  hero: {
    position: 'relative',
    background: '#0d3d2a',
    padding: '32px 36px',
    overflow: 'hidden',
  },
  decCircle: {
    position: 'absolute',
    borderRadius: '50%',
    background: '#fff',
    pointerEvents: 'none',
  },
  heroInner: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: '24px',
    flexWrap: 'wrap',
    position: 'relative',
    zIndex: 1,
  },
  heroLeft: { flex: '1 1 280px' },
  pill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '7px',
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.08em',
    color: '#FBBF24',
    marginBottom: '14px',
    fontFamily: "'Inter', sans-serif",
  },
  pillDot: {
    width: '7px',
    height: '7px',
    borderRadius: '50%',
    background: '#FBBF24',
    display: 'inline-block',
  },
  heroTitle: {
    margin: '0 0 12px',
    fontSize: '28px',
    fontWeight: 800,
    color: '#fff',
    lineHeight: 1.25,
    fontFamily: "'Inter', 'Plus Jakarta Sans', sans-serif",
  },
  heroTitleAccent: {
    color: '#FBBF24',
    fontStyle: 'italic',
  },
  heroSub: {
    margin: '0 0 24px',
    fontSize: '14px',
    color: 'rgba(255,255,255,0.72)',
    lineHeight: 1.6,
    maxWidth: '360px',
  },
  statsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
  stat: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  statNum: {
    fontSize: '16px',
    fontWeight: 700,
    color: '#fff',
    fontFamily: "'Inter', sans-serif",
  },
  statLabel: {
    fontSize: '11px',
    color: 'rgba(255,255,255,0.55)',
    fontFamily: "'Inter', sans-serif",
  },
  statDivider: {
    width: '1px',
    height: '28px',
    background: 'rgba(255,255,255,0.18)',
  },

  /* avatars */
  heroRight: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '10px',
    paddingBottom: '4px',
  },
  avatarGroup: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    width: '34px',
    height: '34px',
    borderRadius: '50%',
    border: '2px solid #0d3d2a',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '11px',
    fontWeight: 700,
    color: '#fff',
    fontFamily: "'Inter', sans-serif",
  },
  avatarMeta: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  avatarMetaNum: {
    fontSize: '13px',
    fontWeight: 700,
    color: '#fff',
    fontFamily: "'Inter', sans-serif",
  },
  avatarMetaSub: {
    fontSize: '11px',
    color: 'rgba(255,255,255,0.55)',
    fontFamily: "'Inter', sans-serif",
  },

  /* form section */
  formSection: {
    background: '#f4f7f5',
    padding: '28px 36px',
  },
  formInner: {
    display: 'flex',
    gap: '48px',
    flexWrap: 'wrap',
  },
  formLeft: { flex: '1 1 260px' },
  formRight: { flex: '1 1 200px' },

  iAmA: {
    margin: '0 0 10px',
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.08em',
    color: '#94a3b8',
    fontFamily: "'Inter', sans-serif",
  },
  toggleRow: {
    display: 'flex',
    gap: '8px',
    marginBottom: '14px',
  },
  toggleActive: {
    display: 'flex',
    alignItems: 'center',
    padding: '9px 16px',
    borderRadius: '8px',
    border: '1.5px solid #1a1a1a',
    background: '#1a1a1a',
    color: '#fff',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: "'Inter', sans-serif",
  },
  toggleInactive: {
    display: 'flex',
    alignItems: 'center',
    padding: '9px 16px',
    borderRadius: '8px',
    border: '1.5px solid #d1d5db',
    background: '#fff',
    color: '#374151',
    fontSize: '13px',
    fontWeight: 500,
    cursor: 'pointer',
    fontFamily: "'Inter', sans-serif",
  },
  roleBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '5px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: 600,
    color: '#166534',
    background: '#dcfce7',
    border: '1px solid #bbf7d0',
    marginBottom: '14px',
  },
  subtext: {
    margin: '0 0 16px',
    fontSize: '13px',
    color: '#64748b',
    lineHeight: 1.55,
  },
  inputRow: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
  },
  inputWrap: {
    flex: '1 1 180px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  inputIcon: {
    position: 'absolute',
    left: '11px',
    pointerEvents: 'none',
  },
  emailInput: {
    width: '100%',
    padding: '10px 12px 10px 34px',
    border: '1.5px solid #e2e8f0',
    borderRadius: '8px',
    fontSize: '13px',
    color: '#1e293b',
    background: '#fff',
    outline: 'none',
    fontFamily: "'Inter', sans-serif",
    boxSizing: 'border-box',
  },
  submitBtn: {
    padding: '10px 20px',
    borderRadius: '8px',
    border: 'none',
    background: '#1a1a1a',
    color: '#fff',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    fontFamily: "'Inter', sans-serif",
  },
  successBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '12px 14px',
    borderRadius: '8px',
    background: '#dcfce7',
    border: '1px solid #86efac',
    fontSize: '13px',
    fontWeight: 600,
    color: '#166534',
  },
  errorMsg: {
    margin: '6px 0 0',
    fontSize: '12px',
    color: '#dc2626',
  },
  disclaimer: {
    margin: '10px 0 0',
    fontSize: '12px',
    color: '#94a3b8',
  },

  /* what you get */
  whatLabel: {
    margin: '0 0 16px',
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.08em',
    color: '#94a3b8',
    fontFamily: "'Inter', sans-serif",
  },
  benefitRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    marginBottom: '16px',
  },
  benefitIcon: {
    flexShrink: 0,
    marginTop: '1px',
  },
  benefitTitle: {
    margin: '0 0 2px',
    fontSize: '13px',
    fontWeight: 700,
    color: '#1e293b',
    fontFamily: "'Inter', sans-serif",
  },
  benefitDesc: {
    margin: 0,
    fontSize: '12px',
    color: '#64748b',
    lineHeight: 1.5,
  },
};

export default NewsletterSection;
